var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWaitingTimeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Time"
  }, /*#__PURE__*/React.createElement("path", {
    id: "sandglass",
    d: "M7.78125 17.3437H16.2188M8.20312 15.6995H15.7969M8.20312 15.6995C8.20312 13.6563 9.90304 12 12 12M8.20312 15.6995V17.3437H15.7969V15.6995M15.7969 15.6995C15.7969 13.6563 14.097 12 12 12M8.20312 8.30048H15.7969M8.20312 8.30048C8.20312 10.3437 9.90304 12 12 12M8.20312 8.30048L8.20312 6.65625L15.7969 6.65625L15.7969 8.30048M15.7969 8.30048C15.7969 10.3437 14.097 12 12 12M7.78125 6.65625H16.2188",
    stroke: "#F0F0F0",
    strokeOpacity: 0.8,
    strokeWidth: 0.75,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaitingTimeIcon);
export default __webpack_public_path__ + "static/media/WaitingTimeIcon.6c3de48e1544e3551cf54950b109e7de.svg";
export { ForwardRef as ReactComponent };